import {
  RUNUP_SEARCH_CLEAR,
  RUNUP_SEARCH_REQUEST,
  RUNUP_SEARCH_CLEAR_REDIRECT,
  RUNUP_SEARCH_AREA_REQUEST,
  RUNUP_SEARCH_COUNTRY_REQUEST,
  RUNUP_SEARCH_REGION_REQUEST,
  RUNUP_SEARCH_RUNUP_AREA_REQUEST,
  RUNUP_SEARCH_RUNUP_REGION_REQUEST,
  RUNUP_SEARCH_RUNUP_COUNTRY_REQUEST,
  RUNUP_SEARCH_RUNUP_MEASURE_TYPE_REQUEST,
  RUNUP_SEARCH_CAUSE_REQUEST,
  RUNUP_SEARCH_VALIDITY_REQUEST,
} from './runupSearchReducer';
import {
  RUNUP_SEARCH_TOGGLE_SECTION,
} from './runupSearchPageReducer';


export const searchRunups = ({
  queryParameters, formModel, location, searchRedirect, history,
}) => ({
  type: RUNUP_SEARCH_REQUEST, queryParameters, formModel, location, searchRedirect, history,
});
export const clearRunupSearch = () => ({ type: RUNUP_SEARCH_CLEAR });
export const toggleSection = ({ section }) => ({ type: RUNUP_SEARCH_TOGGLE_SECTION, section });
export const clearRedirect = () => ({ type: RUNUP_SEARCH_CLEAR_REDIRECT });

export const getRegions = ({ history }) => ({ type: RUNUP_SEARCH_REGION_REQUEST, history });
export const getCountries = ({ history }) => ({ type: RUNUP_SEARCH_COUNTRY_REQUEST, history });
export const getAreas = ({ country, history }) => ({ type: RUNUP_SEARCH_AREA_REQUEST, country, history });

export const getRunupRegions = ({ history }) => ({ type: RUNUP_SEARCH_RUNUP_REGION_REQUEST, history });
export const getRunupCountries = ({ history }) => ({ type: RUNUP_SEARCH_RUNUP_COUNTRY_REQUEST, history });
export const getRunupAreas = ({ country, history }) => ({ type: RUNUP_SEARCH_RUNUP_AREA_REQUEST, country, history });
export const getRunupMeasurementTypes = ({ history }) => ({ type: RUNUP_SEARCH_RUNUP_MEASURE_TYPE_REQUEST, history });
export const getValidity = ({ history }) => ({ type: RUNUP_SEARCH_VALIDITY_REQUEST, history });
export const getCauses = ({ history }) => ({ type: RUNUP_SEARCH_CAUSE_REQUEST, history });
